import * as React from "react";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {AppState} from "../store";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import {
    createSelectCurrentUserWithCondition,
} from "../store/user/selectors";
import {IUser} from "../store/user/types";

interface IOwnProps extends RouteComponentProps {
}

interface IStateProps {
    authorisedUser: IUser | null;
}

interface IDispatchProps {
}

type IProps = IOwnProps & IStateProps & IDispatchProps


export const withAuthorization = (condition: any) => (Component: any) => {
    class WithAuthorization extends React.Component<IProps, {}> {
        public render() {
            const {authorisedUser, staticContext, ...rest} = this.props;

            return (
                authorisedUser ? <Component {...rest}/> : null
            )
        }
    }

    const mapStateToProps = (state: AppState): IStateProps => {
        return {
            authorisedUser: createSelectCurrentUserWithCondition(state, condition)
        }
    };

    const mapDispatchToProps = (
        dispatch: Dispatch
    ): IDispatchProps => {
        return {};
    };

    const connected = connect(
        mapStateToProps,
        mapDispatchToProps,
    )(WithAuthorization);

    return withRouter(connected as any)

};